import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgCardTypeYoutube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M31.252 8.488c-.366-1.37-1.448-2.452-2.824-2.823C25.941 5 15.958 5 15.958 5s-9.977 0-12.47.665c-1.37.366-2.452 1.447-2.823 2.823C0 10.976 0 16.17 0 16.17s0 5.194.665 7.682c.366 1.372 1.447 2.453 2.823 2.823 2.493.666 12.47.666 12.47.666s9.983 0 12.47-.666c1.372-.365 2.453-1.447 2.824-2.823.665-2.488.665-7.682.665-7.682s0-5.194-.665-7.682",
			fill: "#D9252A"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFE",
			d: "M12.77 20.958l8.291-4.788-8.291-4.788v9.576"
		})]
	})
});
export default SvgKgCardTypeYoutube;
